/* eslint-disable no-param-reassign */
// Source: https://addyosmani.com/blog/faster-javascript-memoization/
function memoize(f) {
  return function memoized(...args) {
    const memoizeKey = JSON.stringify(args)

    f.memoize = f.memoize || {}

    if (!(memoizeKey in f.memoize)) f.memoize[memoizeKey] = f.apply(this, args)

    return f.memoize[memoizeKey]
  }
}

export default memoize
